import { UIText1, UIText2 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './styles.css';
import { OptionalAnchor } from '../OptionalAnchor';
import { stopPropagation } from '../../utils/event';

export interface IAboutBuildingProps {
  buildingInfo?: string;
  link?: string;
  name?: string;
}

export class AboutBuilding extends React.Component<IAboutBuildingProps> {
  public render() {
    const { name, buildingInfo } = this.props;

    return (
      <div className={styles['container']}>
        {name && (
          <OptionalAnchor
            href={this.props.link}
            rel="noopener"
            className={styles['name']}
            onAnchorClick={stopPropagation}
          >
            <UIText1 color={this.props.link ? 'text-main-default' : undefined}>{name}</UIText1>
          </OptionalAnchor>
        )}
        {buildingInfo && (
          <UIText2 display="block" color="gray60_100">
            {buildingInfo}
          </UIText2>
        )}
      </div>
    );
  }
}
